import axios from './axios'
import { CreateInstructorDto, InstructorDto, UpdateInstructorDto } from './types'

export const getInstructors = (active?: boolean) => {
  const params = active !== undefined ? { active: String(active) } : {}
  return axios.get<InstructorDto[]>('/instructors', { params })
}

export const getInstructor = (id: string) => {
  return axios.get<InstructorDto>(`/instructors/${id}`)
}

export const createInstructor = (data: CreateInstructorDto) => {
  return axios.post<InstructorDto>('/instructors', data)
}

export const updateInstructor = (id: string, data: UpdateInstructorDto) => {
  return axios.put<InstructorDto>(`/instructors/${id}`, data)
}
